module.exports = __webpack_public_path__ + "static/Gotham-Bold-322990aee0714d2649a61869dfe46935.ttf";